import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { ApiService } from './api.service';
import { UtilService } from './util.service';


@Injectable({ providedIn: 'root' })

export class LabelServices {

    private labelMap = {};
    public label: string

    constructor(private api: ApiService,private util: UtilService) {
        this.util.startLoader()
        this.api.getAllLabel().subscribe(response => {
            this.util.stopLoader()
            response.forEach(ele => {
                this.labelMap[ele.labelCode] = ele.labelName
            });
        })
    }

    getLabel(label) {
        return this.labelMap[label]
    }
}